import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useSuperTenant } from '../../context/SuperAdminTenantContext';

const SuperAdminBar: React.FC = () => {
  const { user } = useAuth();
  const { tenantId, tenant, tenants, setTenantId } = useSuperTenant();

  if (user?.role !== 'super_admin' || tenants.length === 0) return null;

  return (
    <div style={{
      background: '#fdf4ff',
      borderBottom: '1px solid #e9d5ff',
      padding: '6px 24px',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      fontSize: 13,
      flexShrink: 0,
    }}>
      <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#7c3aed" strokeWidth={2.5}>
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <path d="M8 21h8M12 17v4"/>
      </svg>
      <span style={{ color: '#7c3aed', fontWeight: 700 }}>Tenant filter:</span>
      <select
        value={tenantId ?? ''}
        onChange={e => setTenantId(Number(e.target.value) || null)}
        style={{
          padding: '3px 10px', borderRadius: 6,
          border: '1.5px solid #c4b5fd',
          fontSize: 13, fontWeight: 600,
          color: '#5b21b6', background: '#fff',
          cursor: 'pointer',
        }}
      >
        <option value="">All Tenants</option>
        {tenants.map(t => (
          <option key={t.id} value={t.id}>{t.name} ({t.slug})</option>
        ))}
      </select>
      {tenant && (
        <span style={{ fontSize: 12, color: '#a78bfa' }}>ID #{tenant.id}</span>
      )}
    </div>
  );
};

export default SuperAdminBar;
